<template>
  <!-- 已删除员工列表 author: zhangxiaofeng -->
  <div class="table-container">
    <div v-show="!showStaffFiles" class="btn-wrapper flex" id="table-header-wrapper">
      <div class="group-name ellipsis">已删除账号</div>
    </div>
    <div v-show="!showStaffFiles" class="table-wrapper block" id="scrollBody">
      <div v-show="!showStaffFiles" class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height: tableHeight - 10 + 'px'}" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
            <div class="header-item is-leaf" style="width: 320px;">员工账号</div>
            <div class="header-item is-leaf flex-1">姓名</div>
            <!--<div class="header-item is-leaf" style="width: 120px;">密保手机</div>-->
            <div class="header-item is-leaf" style="width: 120px;">删除时间</div>
            <div class="header-item is-leaf" style="width: 80px;">空间大小</div>
            <div class="header-item is-leaf is-operate" style="width: 70px;">操作</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" ref="containerWrapper">
            <li class="flex flex-row row row--level-1" :style="{width: tableWidth - 8 + 'px'}" v-for="(item, index) in staffList" :key="index">
              <div class="cell column_1" style="width: 320px;">{{item.account}}</div>
              <div class="cell column_2 flex-1">{{item.name}}</div>
              <!--<div class="cell column_4" style="width: 120px;">{{item.passwordMobile}}</div>-->
              <div class="cell column_5" style="width: 120px;">{{item.deleteTime | formatDate()}}</div>
              <div class="cell column_8 is-left" style="width: 80px;">
                {{item.size}}
              </div>
              <div class="cell column_9 is-operate" style="width: 70px;">
                <div style="width: 100%;">
                  <w-dropdown @command="handleAction">
                    <span class="w__dropdown-link">
                       <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i>
                       </span>
                    </span>
                    <w-dropdown-menu slot="dropdown">
                      <w-dropdown-item :command="{item, type: 'view'}">查看工程</w-dropdown-item>
                      <w-dropdown-item :command="{item, type: 'copy'}">复制数据</w-dropdown-item>
                      <w-dropdown-item :command="{item, type: 'restore'}">恢复账号</w-dropdown-item>
                      <w-dropdown-item :command="{item, type: 'delete'}" divided>彻底删除</w-dropdown-item>
                    </w-dropdown-menu>
                  </w-dropdown>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div ref="pagenationContainer" class="text-align-right padding-top-5" v-if="staffList.length">
      <w-pagination @current-change="handleCurrentChange" @size-change="handlePageSizeChange"
        :current-page.sync="pagination.pageNum" background layout="total, prev, pager, next, jumper,sizes"
        :page-size="pagination.pageSize" :page-sizes="[50, 100]" :total="pagination.total"></w-pagination>
    </div>
    <!-- 彻底删除 确认弹窗 -->
    <w-dialog :show="showDeleteConfirm" class="delete-confirm"
              :box-style="{width: 'auto'}"
              :body-style="{width: '400px', boxSizing: 'border-box'}"
              :footer-style="{borderTop: 'none'}">
      <div class="confirm-content">
        <p class="confirm-title f-cb">
          <i class="r2-icon-action_report_problem float_left"></i>
          <span class="title float_left">确定要彻底删除员工？</span>
        </p>
        <p class="confirm-tips">彻底删除后，该员工账号将不能恢复</p>
      </div>
      <div slot="footer">
        <w-button type="primary" @click="submitDelete">确定</w-button>
        <w-button type="minor" @click="showDeleteConfirm = false">取消</w-button>
      </div>
    </w-dialog>

    <router-view></router-view>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .delete-confirm{
    font-size: 14px;
    .confirm-title{
      line-height: 32px;
      .r2-icon-action_report_problem{
        font-size: 32px;
        color: #E02020;
      }
      .title{
        font-size: 16px;
        font-weight: 600;
        color: #212530;
        margin-left: 16px;
      }
    }
    .confirm-tips{
      margin-top: 8px;
      color: rgba(33, 37, 48, 0.55);
      padding-left: 48px;
      box-sizing: border-box;
    }
  }
</style>
<script>
import manageService from '@/assets/service/manage'
import {on, sizeConver, formatDay} from '@/assets/utils'
export default {
  name: 'StaffDeleted',
  props: {
    tableHeight: {
      type: Number,
      default: 100
    }
    // tableWidth: {
    //   type: Number,
    //   default: 100
    // }
  },
  data () {
    return {
      tableWidth: 100,
      scrollY: false,
      loading: false,
      staffList: [],
      currentRow: {},
      showDeleteConfirm: false,
      pagination: {
        total: 0,
        current: 1,
        pageNum: 1,
        pageSize: 50,
        showSizeChanger: true,
        showQuickJumper: true,
        hideOnSinglePage: true
      }
    }
  },
  computed: {
    // 显示某个员工的 空间文件列表
    showStaffFiles () {
      return (this.$route.params && this.$route.params.gldUserId)
    }
  },
  filters: {
    formatDate (val) {
      return formatDay(new Date(val))
    }
  },
  mounted () {
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    this.getEmployeeList()
    this.tableWidth = this.getDomWidth('scrollBody')
    this.resizeHandle.resize(() => {
      setTimeout(() => {
        this.tableWidth = this.getDomWidth('scrollBody')
      }, 200)
    })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
    // scrollY && this.calcTableHeight()
  },
  methods: {
    // 分页
    handleCurrentChange (index){
      this.pagination.pageNum = index
      this.getEmployeeList()
    },
    handlePageSizeChange (index){
      this.pagination.pageSize = index
      this.pagination.pageNum = 1
      this.getEmployeeList()
    },
    // 获取员工列表
    getEmployeeList () {
      let params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        deleted: 1,
        departmentId: '',
        keyword: ''
      }
      this.loading = true
      manageService.getEmployeeList(params).then(res => {
        this.loading = false
        const data = res.data || {}
        let { items = [], total } = data
        this.pagination.total = total
        items.forEach(item => {
          item.size = sizeConver(item.workspaceCapacity || 0)
        })
        this.staffList = items
      }).catch(() => {
        this.loading = false
        this.staffList = []
      })
    },
    // 表格滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    // 操作列事件
    handleAction ({item, type}) {
      this.currentRow = item
      switch (type) {
        // 查看工程
        case 'view':
          this.sentLog(100117036)
          const {gldUserId, name, account, workspaceId} = item
          if (workspaceId) {
            // : '1d36ac7f3f024f62ae93e2da642d4250'
            this.$router.push({
              path: '/manage/members/deleted/' + gldUserId,
              query: { name, account, workspaceId }
            })
          } else {
            this.$message.error('该用户从未登陆过造价云，操作无效')
          }
          break
        // 复制数据
        case 'copy':
          this.$confirm({
            type: 'warning',
            width: 400,
            message: '确定要复制数据吗？',
            tips: '确定后此员工的的清单、定额、人材机、组价数据将复制到企业电子档案室。',
            submit: () => {
              this.submitCopy()
            }
          })
          break
        // 恢复账号
        case 'restore':
          this.$confirm({
            type: 'warning',
            width: 400,
            message: '确定要恢复账号吗？',
            tips: '恢复账号 <span class="restore-name" style="color: #2079FA;">' + item.account + '</span>',
            submit: () => {
              this.submitRestore()
            }
          })
          break
        // 彻底删除
        case 'delete':
          this.showDeleteConfirm = true
          break
        default:
        // console.log('default');
      }
    },
    // 复制数据 确定
    submitCopy () {
      this.sentLog(100117039)
      manageService.copyData({ importGldUserId: this.currentRow.gldUserId, spaceType: 2, importUserName: this.currentRow.account }).then((res) => {
        console.log(res)
        if (res && +res.code === 200) {
          this.$message.info('数据提交中 ...')
        } else {
          this.$message.error(res.message)
        }
      }).catch((e) => {
        console.log(e)
        this.$message.error('请求失败')
      })
    },
    // 恢复账号 确定
    submitRestore () {
      manageService.restore({ gldUserId: this.currentRow.gldUserId }).then((res) => {
        console.log(res)
        if (res && +res.code === 200) {
          manageService.addRelationLog({
            area: this.userInStore.area,
            detail: `${this.currentRow.account}被复原`,
            operateType: 'EDIT_ACCOUNT',
            relType: '',
            showState: 1
          })
          this.sentLog(100117040, { status: 1 })
          this.$message.success('恢复成功')
          this.getEmployeeList()
        } else {
          switch (+res.code) {
            case 200046: // 无效的恢复账号
              this.$message.error('无效的恢复账号')
              break
            case 200047: // 系统中有重名账号，恢复失败
              this.$message.error('系统中有重名账号，恢复失败')
              break
            default:
              this.$message.error('恢复失败')
          }
          this.sentLog(100117040, { status: 2, message: res.message || '恢复失败' })
        }
      }).catch((e) => {
        console.log(e)
        this.$message.error('请求失败')
      })
    },
    // 彻底删除 确定
    submitDelete () {
      this.showDeleteConfirm = false
      this.sentLog(100117041)
      manageService.deleteEmployee({ gldUserId: this.currentRow.gldUserId, deleted: 1 }).then((res) => {
        console.log(res)
        if (res && +res.code === 200) {
          manageService.addRelationLog({
            area: this.userInStore.area,
            detail: `${this.currentRow.account}`,
            operateType: 'COMPLETELY_DELETE_ACCOUNT',
            relType: '',
            showState: 1
          })
          this.$message.success('删除成功')
          this.getEmployeeList()
        } else {
          this.$message.error('删除失败')
        }
      }).catch((e) => {
        console.log(e)
        this.$message.error('请求失败')
      }).finally(() => {
        this.showDeleteConfirm = false
      })
    }
  }
}
</script>
